import { render } from "./NewMessageModal.vue?vue&type=template&id=21d4bc98"
import script from "./NewMessageModal.vue?vue&type=script&lang=js"
export * from "./NewMessageModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodeapps/vitamins/projectivegroup/frontendBuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__